import { Component } from '@angular/core';

@Component({
  selector: 'app-callback',
  template: `<p>Signing you in...</p>`
})
export class CallbackComponent {}
